import React, { useMemo } from 'react';
import { Box, Button } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import pallet from '../../../layouts/pallet';
import { User } from '../../../types/userType';
import { dataGridSx } from '../../common/styled/DataGrid';
import tableColumnUtils from '../../../utils/tableColumnUtils';

interface ConsolidatedMarksReportTableProps {
  studentDetails: User[];
  isLoading: boolean;
  onGenerateReportCard: (studentId: string) => void;
  isDownloadInProgress: boolean;
}

const ConsolidatedMarksReportTable: React.FC<
  ConsolidatedMarksReportTableProps
> = ({
  studentDetails,
  isLoading,
  onGenerateReportCard,
  isDownloadInProgress
}) => {
  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: 'enrollmentNo',
        headerName: 'Enrollment No',
        flex: 1,
        minWidth: 140,
        disableColumnMenu: true
      },
      {
        field: 'name',
        headerName: 'Student Name',
        flex: 1,
        minWidth: 180,
        disableColumnMenu: true
      },
      {
        field: 'action',
        headerName: 'Action',
        // flex: 1,
        minWidth: 240,
        sortable: false,
        headerAlign: 'center',
        disableColumnMenu: true,
        renderCell: (params) => (
          <Button
            variant='contained'
            onClick={() => onGenerateReportCard(params.row.id)}
            disabled={isDownloadInProgress}
          >
            Generate Report Card
          </Button>
        )
      }
    ],
    [onGenerateReportCard, isDownloadInProgress]
  );

  return (
    <Box sx={{ width: '100%' }}>
      <DataGrid
        rows={studentDetails}
        columns={columns}
        loading={isLoading || isDownloadInProgress}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        disableColumnMenu
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </Box>
  );
};

export default ConsolidatedMarksReportTable;
